import { DriverService } from "./../../../services/catalogs/DriverService";
import { CreateDriverDto } from "../../../dtos/catalogs/driver/CreateDriverDto";
import React from "react";
import { DriverDetail } from "../../../components/Pages/Catalogs/Driver/DriverDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupDriver } from "../../../components/Shared/NewForms/NFLookupDriver";
import DriverList from "../../../components/Pages/Catalogs/Driver/DriverList";

export const Driver: IAppEntity = {
  entityType: "catalog",
  title: "Driver",
  pluralTitle: "Driver",
  apiUrl: "Drivers",
  apiEnum: ReferenceTypes.CatalogDriver,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(DriverDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DriverList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDriver, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new DriverService(this.apiUrl);
  },
  getEmptyModel(): CreateDriverDto {
    return {
      name: "",
      createdDate: new Date(),
    };
  },
};
